import { Input, Output, EventEmitter, Component } from "@angular/core";
import { Product } from '../../Model/Catalog/product';
import { ModelService } from "../../Services/model.service";


@Component({
  selector: "misc",
  templateUrl: "misc.html",
  styleUrls: ["./misc.css", "template.css"]
})
export class Misc {
  @Input() model: Product = null;

  @Output() onValueChanged = new EventEmitter<any>();

  @Input() templateView: Boolean = false;
  @Input() selectedElements: string[] = [""];
  @Input() exportMode: Boolean = false;
  @Output() elementSelected = new EventEmitter<string>();

  @Input() showDragHandle: boolean = false;
  @Input() dragFilter: string = "noDrag";

  @Output() excelElementDropped = new EventEmitter<any>();

  constructor(public modelService: ModelService) { }

  update(event = null) {
    this.onValueChanged.emit(event);
  }

  public elementSelectFunction(event) {
    this.elementSelected.emit(event);
  }

  public excelElementDrop(e) {
    this.excelElementDropped.emit(e);
  }






  selectItemsND = ["NORMAL", "DELETE"];
  selectItemsNDI = ["NORMAL", "DELETE", "IGNORE_EMPTY_FIELDS"];



  private _mimeUpdateMode: string = "NORMAL";

  get mimeUpdateMode(): string {
    return this._mimeUpdateMode;
  }

  @Input()
  set mimeUpdateMode(value: string) {
    this._mimeUpdateMode = value;
  }

  @Output() onMimeUpdateModeChanged = new EventEmitter<string>();

  mimeUpdateModeChanged(e) {
    this.onMimeUpdateModeChanged.emit(e);
  }



  private _featureUpdateMode: string = "NORMAL";

  get featureUpdateMode(): string {
    return this._featureUpdateMode;
  }

  @Input()
  set featureUpdateMode(value: string) {
    this._featureUpdateMode = value;
  }

  @Output() onFeatureUpdateModeChanged = new EventEmitter<string>();

  featureUpdateModeChanged(e) {
    this.onFeatureUpdateModeChanged.emit(e);
  }



  private _priceUpdateMode: string = "NORMAL";

  get priceUpdateMode(): string {
    return this._priceUpdateMode;
  }

  @Input()
  set priceUpdateMode(value: string) {
    this._priceUpdateMode = value;
  }

  @Output() onPriceUpdateModeChanged = new EventEmitter<string>();

  priceUpdateModeChanged(e) {
    this.onPriceUpdateModeChanged.emit(e);
  }


  private _supplierUpdateMode: string = "NORMAL";

  get supplierUpdateMode(): string {
    return this._supplierUpdateMode;
  }

  @Input()
  set supplierUpdateMode(value: string) {
    this._supplierUpdateMode = value;
  }

  @Output() onSupplierUpdateModeChanged = new EventEmitter<string>();

  supplierUpdateModeChanged(e) {
    this.onSupplierUpdateModeChanged.emit(e);
  }  



  private _categoryUpdateMode: string = "NORMAL";

  get categoryUpdateMode(): string {
    return this._priceUpdateMode;
  }

  @Input()
  set categoryUpdateMode(value: string) {
    this._categoryUpdateMode = value;
  }

  @Output() onCategoryUpdateModeChanged = new EventEmitter<string>();

  categoryUpdateModeChanged(e) {
    this.onCategoryUpdateModeChanged.emit(e);
  }


  private _udxUpdateMode: string = "NORMAL";

  get udxUpdateMode(): string {
    return this._udxUpdateMode;
  }

  @Input()
  set udxUpdateMode(value: string) {
    this._udxUpdateMode = value;
  }

  @Output() onUdxUpdateModeChanged = new EventEmitter<string>();

  udxUpdateModeChanged(e) {
    this.onUdxUpdateModeChanged.emit(e);
  }
}
